import { createContext } from 'react'

/**
 * The browser's pathname. While a masonry viewer is open the layout renders
 * under the parent page's location, so it reads the real URL from here.
 */
export const RealPathnameContext = createContext(null)
